<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div slot="modal-header" class="w-100">
            <div class="row">
                <div class="col-sm-12 text-center"><b>{{$t("action.cancel")}}</b></div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 px-0">
<!--                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                  <div class="form-group">
                                  <label>{{$t("realEstate.field.rejectText")}} <span class="red">*</span></label>
                                  <textarea class="form-control" v-model="data.comment"
                                            :class="{invalid : $v.data.comment.$error}"
                                  ></textarea>
                                  <div class="red" v-if="$v.data.comment.$error">
                                    {{$t("realEstate.field.rejectText")}}
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <div class="form-group">
                      <label>{{$t("realEstate.field.rejectText")}} <span class="red">*</span></label>
                      <textarea class="form-control h-100" v-model="data.comment"
                                :class="{invalid : $v.data.comment.$error}"
                      ></textarea>
                      <div class="red" v-if="$v.data.comment.$error">
                        {{$t("realEstate.field.rejectText")}}
                      </div>
                    </div>
                  </div>
            </div>
        </div>
        <div slot="modal-footer" style="width: 100%">
            <button class="all-btn delete-btn float-right" @click="reject">
                <i class="fa fa-reply-all"></i>
                <span>Рад қилиш</span>
            </button>
            <button class="all-btn delete-btn float-left" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

    export default {
        name: "RejectComment",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                processing: false,
                show: false,
                data: {
                    rejectObjectId: null,
                    comment: null
                },
                isLoses: false
            }
        },
        validations() {
            return {
                data: {
                    comment: {
                        required: required
                    }
                }
            };
        },
        methods: {
            reject() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                if (vm.data && vm.data.rejectObjectId) {
                    vm.$http.post('common/reject', vm.data).then(function (res) {
                        if (res.data.status === "SUCCESS") {
                            if (vm.evlType === "Fitment") {
                                vm.$router.push('/fitment/list');
                            } else {
                                if (!vm.isLoses) {
                                    vm.$eventBus.$emit('AutoAct');
                                } else {
                                    vm.$router.push('/auto/loses-list');
                                }
                            }
                        }
                    });
                }
            },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on('RejectComment', (id, isLoses, evlType) => {
                this.show = true;
                this.data.rejectObjectId = id;
                this.isLoses = isLoses;
                this.evlType = evlType;
            });
        }
    }
</script>

<style>
    .modal-content {
        width: 100%;
    }
</style>